<template>
  <div class="tab1">
    <van-tabs v-model="active" class="home-tab" color="#666" line-width="25%">
      <van-tab title="烘焙甜点">
        <div class="d1"></div>
        <div class="class">
          <router-link to="/baking15">
            <van-image
              src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/index/baking15.jpg"
            >
              <template v-slot:loading>
                <van-loading size="20" color="#fff" />
              </template>
            </van-image>
          </router-link>
          <router-link to="/baking9">
            <van-image
              src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/index/baking9.jpg"
            >
              <template v-slot:loading>
                <van-loading size="20" color="#fff" />
              </template>
            </van-image>
          </router-link>
             <router-link to="/duanqi">
            <van-image
              src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/index/duanqi.jpg"
            >
              <template v-slot:loading>
                <van-loading size="20" color="#fff" />
              </template>
            </van-image>
          </router-link>
          <!-- <div class="d1-flex">
            <router-link to="/baking6" style="width:32.3%">
              <van-image
                src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/index/baking6.jpg"
              >
               
              </van-image>
            </router-link>
              <router-link to="/duanqi" style="width:66.3%">
            <van-image
              src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/index/major4-6.jpg"
            >
             
            </van-image>
          </router-link>
          </div> -->
        </div>
      </van-tab>
      <van-tab title="西餐料理">
        <div class="d2"></div>
        <div class="class">
          <router-link to="/westfood9">
            <van-image
              src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/index/westfood9.jpg"
            >
              <template v-slot:loading>
                <van-loading size="20" color="#fff" />
              </template>
            </van-image>
          </router-link>
          <router-link to="/westfood6">
            <van-image
              src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/index/westfood6.jpg"
            >
              <template v-slot:loading>
                <van-loading size="20" color="#fff" />
              </template>
            </van-image>
          </router-link>
          <div class="d1-flex">
            <router-link to="chat" style="width:49.3%">
              <van-image
                src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/index/westfoodtalk.jpg"
              >
                <template v-slot:loading>
                  <van-loading size="20" color="#fff" />
                </template>
              </van-image>
            </router-link>
            <a href="tel:02887507333" style="width:49.3%">
              <van-image
                src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/index/westfoodcall.jpg"
              >
                <template v-slot:loading>
                  <van-loading size="20" color="#fff" />
                </template>
              </van-image>
            </a>
          </div>
        </div>
      </van-tab>
      <van-tab title="咖啡饮品">
        <div class="d3"></div>
        <div class="class">
          <router-link to="/coffee">
            <van-image
              src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/newindex/kafei.jpg"
            >
              <template v-slot:loading>
                <van-loading size="20" color="#fff" />
              </template>
            </van-image>
          </router-link>
          <div class="d1-flex">
            <router-link to="/coffee" style="width:49.3%">
              <van-image
                src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/newindex/kafei-left.jpg"
              >
                <template v-slot:loading>
                  <van-loading size="20" color="#fff" />
                </template>
              </van-image>
            </router-link>
           <router-link to="/hksweet" style="width:49.3%">
              <van-image
                src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/newindex/kafei-right.jpg"
              >
                <template v-slot:loading>
                  <van-loading size="20" color="#fff" />
                </template>
              </van-image>
            </router-link>
          </div>
        </div>
      </van-tab>
      <van-tab title="精品调酒">
        <div class="d4"></div>
        <div class="class">
          <router-link to="/wine">
            <van-image
              src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/newindex/tiaojiu.jpg"
            >
              <template v-slot:loading>
                <van-loading size="20" color="#fff" />
              </template>
            </van-image>
          </router-link>
          <div class="d1-flex">
            <router-link to="/wine" style="width:49.3%">
              <van-image
                src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/newindex/tiaojiu-left.jpg"
              >
                <template v-slot:loading>
                  <van-loading size="20" color="#fff" />
                </template>
              </van-image>
            </router-link>
            <a href="tel:02887507333" style="width:49.3%">
              <van-image
                src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/newindex/tiaojiu-right.jpg"
              >
                <template v-slot:loading>
                  <van-loading size="20" color="#fff" />
                </template>
              </van-image>
            </a>
          </div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
/deep/ .van-tab--active {
  background: #aa6b01;
  color: #fff;
  font-weight: 600;
}
/deep/ .van-tab {
  position: relative;
  font-size: 19px;
  font-weight: 600;
}
/deep/ .van-tabs__nav--line {
  padding-bottom: 20px;
}
.d1,
.d2,
.d3,
.d4 {
  position: absolute;
  margin-left: 10px;
  float: left;
  width: 0;
  height: 0;
  top: 43px;
  border-width: 7px;
  border-style: solid;
  border-color: #aa6b01 transparent transparent transparent;
  left: 8.5%;
}
.d1 {
  left: 8.5%;
}
.d2 {
  left: 33.5%;
}
.d3 {
  left: 58.5%;
}
.d4 {
  left: 83%;
}
.tab1 {
  width: 100%;
  height: 444px;
}
.class {
  width: 100%;
  height: 100px;
  margin-top: 20px;
}
.d1-flex {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
</style>
